export default __webpack_public_path__ + "static/media/sinInternet.7835d5e4.svg";